import PresenceAvatars from "./PresenceAvatars"

const ChatPresenceIndicator = ({ isAdmin, presenceUsers }) => {
  if (!isAdmin || !presenceUsers || presenceUsers.length === 0) return null
  return (
    <div className="flex items-center scale-110 origin-right p-0.5 rounded-full bg-white ring-2 ring-emerald-400 shadow-md">
      <PresenceAvatars users={presenceUsers} />
    </div>
  )
}

export default ChatPresenceIndicator
